import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDogearFav = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 28,
	viewBox: "0 0 22 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_1705_120127)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M5 1.5C5 1.22386 5.22386 1 5.5 1H16.5C16.7761 1 17 1.22386 17 1.5V18.191C17 18.5627 16.6088 18.8044 16.2764 18.6382L11.2236 16.1118C11.0828 16.0414 10.9172 16.0414 10.7764 16.1118L5.72361 18.6382C5.39116 18.8044 5 18.5627 5 18.191V1.5Z",
				fill: "#F2C010"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M5.5 0.75C5.08579 0.75 4.75 1.08579 4.75 1.5V18.191C4.75 18.7485 5.33673 19.1111 5.83541 18.8618L10.8882 16.3354C10.9586 16.3002 11.0414 16.3002 11.1118 16.3354L16.1646 18.8618C16.6633 19.1111 17.25 18.7485 17.25 18.191V1.5C17.25 1.08579 16.9142 0.75 16.5 0.75H5.5Z",
				stroke: "#FEFCF5",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7143 4.27802C10.8041 4.00162 11.1951 4.00162 11.2849 4.27802L12.1446 6.92392C12.1848 7.04752 12.3 7.13121 12.4299 7.13121L15.212 7.13121C15.5026 7.13121 15.6235 7.5031 15.3883 7.67392L13.1376 9.30917C13.0325 9.38556 12.9885 9.52097 13.0286 9.64458L13.8883 12.2905C13.9781 12.5669 13.6618 12.7967 13.4267 12.6259L11.1759 10.9906C11.0708 10.9142 10.9284 10.9142 10.8233 10.9906L8.57254 12.6259C8.33742 12.7967 8.02108 12.5669 8.11089 12.2905L8.97059 9.64458C9.01075 9.52097 8.96676 9.38556 8.86161 9.30917L6.61087 7.67392C6.37576 7.5031 6.49659 7.13121 6.78721 7.13121L9.56927 7.13121C9.69924 7.13121 9.81443 7.04752 9.85459 6.92392L10.7143 4.27802Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_1705_120127",
			x: .5,
			y: .5,
			width: 21,
			height: 26.6924,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "multiply",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1705_120127"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_1705_120127",
					result: "effect2_dropShadow_1705_120127"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_1705_120127",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgDogearFav;
